import React, { useContext } from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { AuthContext } from "../../contexts/AuthContext";

export default function NavbarOptions(props) {
  const { list } = props
  const { userInfo } = useContext(AuthContext);

  const renderOptions = () => {
    return (
      list &&
      list.map(item => {
        if ("val" in item && !item.val(userInfo)) return null;
        return (
          <li className={`NavbarOptions-item ${item.className}`}>
            <Link className="NavbarOptions-link" to={item.link}>
              {item.text}
            </Link>
          </li>
        )
      })
    )
  }

  return <ul className="NavbarOptions-list">{renderOptions()}</ul>
}

NavbarOptions.propTypes = {
  list: PropTypes.array,
}

NavbarOptions.defaultProps = {
  list: [],
}
